import Filters from '@wwdev/product/filters';
import SearchRequest from '@wwdev/product/SearchRequest';
import AddToCart from "../../../vendor/product/AddToCart";

class CustomFilters extends Filters {
	constructor(config) {
		super(Object.assign({
			types: '[data-scope="types"]',
			search: '[data-scope="search"]',
			selectedFilters: '[data-scope="selected-filters"]',
		}, config));
	}

	initEventListeners() {

		$(this.config.filters).off('.product')
			.on('click.product', '[data-filter]', this.handleFilterClick.bind(this))

			.on('change.product', 'input[name="max_price"]', this.handleInputKeyValue.bind(this))
			.on('change.product', 'input[name="min_price"]', this.handleInputKeyValue.bind(this))
		;
		$(this.config.selectedFilters).off('.product')
			.on('click.product', '[data-remove-filter]', this.removeFilter.bind(this))
			.on('click.product', '.filters-reset', this.resetFilter.bind(this))
		;

		$(this.config.paginator).off('.product')
			.on('click.product', 'a.page-link', this.handlePage.bind(this));
		$(this.config.sort).off('.product')
			.on('change.product', 'select', this.handleSort.bind(this));
		$(this.config.limit).off('.product')
			.on('change.product', 'select', this.handleLimit.bind(this));

		$(this.config.types).off('.product')
			.on('click.product', '[data-filter]', this.handleFilterClick.bind(this))
		this.openMobileFilters();
		this.closeMobileFilters();
		this.toggleFilters();
		$(this.config.search)
			// .on('change.product', 'input[name="q"]', this.handleInputKeyValue.bind(this))
			.on('keyup.product', 'input[name="q"]', this.handleInputKeyValue.bind(this))
			.on('search', 'input[name="q"]', this.handleInputKeyValue.bind(this))
	}

	removeFilter(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		this._removeFilter($button.data('tree-id'), $button.data('remove-filter'));
	}

	handleInputKeyValue(e) {
		this.timeout ? clearTimeout(this.timeout) : null;
		let $input = jQuery(e.target);
		let key = $input.attr('name');
		SearchRequest.setByKeyValue(key, $input.val());
		this.timeout = setTimeout(() => {
			this.reload();
		}, 200)

		return false;
	}

	_removeFilter(treeId, filterId) {
		SearchRequest.clearFilter(treeId, filterId);
		this.reload();
	}

	handleResponse(response) {
		$(this.config.types).html(response.types);
		$(this.config.selectedFilters).html(response.selectedFilters);

		super.handleResponse(response);
	}

	beforeCallback() {
		super.beforeCallback();
		// show loader
		jQuery('#spinner').removeClass('d-none');
	}

	afterCallback() {
		super.afterCallback();

		// hide loader
		jQuery('#spinner').addClass('d-none');
		new AddToCart({
			scope: '[data-scope="products"] [data-add-to-cart="scope"]'
		})
	}

	openMobileFilters() {
		$('.open-filters').on('click', () => {
			$('.mobile-filters').addClass('open');
			$('.close-filters').removeClass('d-none');
			$('body').addClass('mobile-filter-bg');
		});
	}

	toggleFilters() {
		$('.show_more_filters').on('click', (e) => {
			let $button = $(e.currentTarget);
			$button.parent('.collapse').find('.default-hided').toggleClass('d-none');
			if (!$button.hasClass('open')) {
				$button.text('Minder filters');
				$button.addClass('open');
			} else {
				$button.text('Meer filters');
				$button.removeClass('open');
			}
		});
	}

	closeMobileFilters() {
		$('.close-filters').on('click', () => {
			$('.mobile-filters').removeClass('open');
			$('.close-filters').addClass('d-none');
			$('body').removeClass('mobile-filter-bg');
		});
	}
}

export default CustomFilters;